import styled, { css } from "styled-components";
import { IThemeProps, themeTypes } from "../../../interfaces";
import { background, inactiveItens, shadowColor } from "../../../theme";

export const Container = styled.div<IThemeProps>`
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 0.3125rem;
    min-width:80vw;
    max-width:80vw;
    min-height: calc(90 * var(--vh));
    max-height: calc(90 * var(--vh));
    outline: 0;
    box-shadow: 0.125rem 0.125rem 0.5rem ${props => shadowColor[props.theme as themeTypes]};
    ${props => css`
        background: ${background[props.theme as themeTypes]};
        color: ${inactiveItens[props.theme as themeTypes]};
    `}
`

export const Form = styled.form`
    display: flex;
    justify-content:space-between;
    flex-direction: column;
    gap: 20px;
`